import { Formik } from "formik";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, ModalBody, Row } from "reactstrap";
import { createAppointment } from "../../redux/actions/api/apiAction";
import { AppointmentForm } from "./appointmentForm";
import { AppointmentTitle } from "./modalTitle";
import { AppointmentSchema } from "./utils";
import _ from "lodash";
import { addServiceModal } from "../../redux/actions/sidebar/sidebarAction";
import { toastr } from "react-redux-toastr";

export const AddAppointment = ({ toggleModal }) => {
  let name = useMemo(() => "", []),
    packages = useMemo(() => [], []),
    price = useMemo(() => "", []),
    trainers = useMemo(() => [], []),
    allowOnlineBooking = useMemo(() => false, []),
    allowCancelation = useMemo(() => false, []),
    allowUnpaidBooking = useMemo(() => false, []),
    noShowDeduction = useMemo(() => false, []),
    description = useMemo(() => "", []),
    payRates = "",
    appointmentType = null;
  const { serviceModal } = useSelector((state) => state.sidebar);
  const { loading } = useSelector((state) => state.gym);

  const { gym } = useSelector((state) => state.gym);
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    const req = _.cloneDeep(values);
    req.packages.forEach((pack, idx) => {
      req.packages[idx] = {
        id: pack.value,
        count: pack.count || parseInt(pack.sessionCount),
      };
    });
    req.payrateId =
      req?.payRates && req?.payRates.lenght ? req?.payRates[0]?.id : null;
    req.appointmentType = req?.appointmentType && req?.appointmentType.value;
    console.log({ req });
    dispatch(createAppointment(req));
  };

  return (
    <>
      <AppointmentTitle
        title={
          gym.type == "sportClub" ? "Add Private Lesson" : "Add Appointment"
        }
        subTitle={
          gym.type == "sportClub"
            ? "Add info about Private Lesson "
            : "Add info about the Appointment"
        }
      />
      <ModalBody className="mx-4 py-5">
        <Formik
          validationSchema={AppointmentSchema}
          initialValues={{
            name,
            duration: "",
            price,
            description,
            noShowDeduction,
            allowOnlineBooking,
            allowCancelation,
            allowUnpaidBooking,
            trainers,
            packages,
            court: null,
            payRates: null,
            coachingType:null
          }}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, setFieldValue, handleChange }) => (
            <AppointmentForm
              values={values}
              setFieldValue={setFieldValue}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
            />
          )}
        </Formik>
        <Row>
          <Col md={12} className="pl-0">
            <div className="action-wrapper blk-padding-y">
              <div className="action-inner-block">
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-medium btn-transparent mr-4"
                    onClick={() => {
                      toggleModal
                        ? toggleModal()
                        : serviceModal
                        ? dispatch(addServiceModal(false))
                        : toastr.error(
                            "Some error occured, please refresh the page"
                          );
                    }}
                  >
                    Cancel
                  </button>
                </React.Fragment>
                <button
                  className="btn btn-medium"
                  type="submit"
                  form="add-appointment"
                  disabled={loading}
                >
                  {gym.type == "sportClub"
                    ? "ADD Private Lesson "
                    : "ADD APPOINTMENT"}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </>
  );
};
